

<div class="container">
  <div class="row" *ngIf="statuslimpio" style="background-color: lightgray;">
    <div class="col">
      <p>1. Seleccione un rango de fechas</p>
      <app-rangodefechas></app-rangodefechas>
    </div>
    
    <div class="col" *ngIf="cuenca != 'VMM-total' && cuenca != 'Putumayo-total'">
      <p>3. Seleccione Unidad de Negocio</p>
      <div class="form-group">
        <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="unidadDeNegocioSeleccionada" (ngModelChange)="seleccionaLocacion($event)" >
          <option>Drilling</option>
          <option>Producción</option>
          <option>Proyectos y facilidades</option>
          <option>Workover</option>
          <option>Sísmica</option>
          <option>Logística</option>
          <option>Mantenimiento</option>
          <option>Administración</option>
        </select>
      </div>



    </div>
    <div class="col">
      <p>4. Haga click en el botón para generar el reporte</p>
      <button *ngIf="statuslimpio" class="btn-warning  btn-block" (click)="generarReporte()">Generar reporte</button>
      <button *ngIf="statuslimpio" class="btn-warning  btn-block" (click)="customScript()">customScript</button>
      
    </div>
  </div>

  <div class="row" *ngIf="! statuslimpio">
    <div class="col">
      <p><small><strong>Desde:</strong> {{servicioFechasQueryService.fechaquerymin}}</small></p>
      <p><small><strong>Hasta:</strong> {{servicioFechasQueryService.fechaquerymax}}</small></p>
    </div>
    <!-- <div class="col">
      <p><small><strong>Cuenca:</strong> {{cuenca}}</small></p>
      <p><small *ngIf="! todalacuenca"><strong>Locación:</strong> {{locacion}}</small></p>
      <p><small *ngIf="todalacuenca"><strong>Toda la cuenca</strong></small></p>
    </div> -->
    <div class="col">
      <p><strong>{{unidadDeNegocioSeleccionada}}</strong></p>
    </div>
    <div class="col">
      <button  class="btn-default  btn-block" (click)="nuevoReporte()">Nuevo reporte</button>
    </div>
  </div>
  <div *ngIf="alertaActiva">
    <ngb-alert #selfClosingAlert  type="warning" >
       <div class="spinner-border" role="status">
         <span class="sr-only"></span>
       </div>
       Cargando data...
     </ngb-alert>
  </div>
    <hr>
    <p><strong>Tareas críticas en {{unidadDeNegocioSeleccionada}}</strong></p>
    <hr>  
  <div class="row">
    <div class="col">
      <ngx-charts-bar-horizontal
      [scheme]="colorScheme"
      [results]="dataChart1"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [legend]="showLegend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
      (select)="onSelect($event)"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)">
    </ngx-charts-bar-horizontal>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <ngx-charts-number-card
        [view]="view"
        [scheme]="colorScheme"
        [results]="dataChart2"
        [cardColor]="cardColor"
        (select)="onSelect($event)">
      </ngx-charts-number-card>
    </div>
    <div class="col">
      <ngx-charts-number-card
        [view]="view"
        [scheme]="colorScheme"
        [results]="dataChart3"
        [cardColor]="cardColor"
        (select)="onSelect($event)">
      </ngx-charts-number-card>
    </div>
  </div>
  <hr>
  <div style="height: 250px;"> <!-- Adjust the height value as needed -->
    <ngx-charts-bar-horizontal
      [scheme]="colorScheme"
      [results]="dataChart4"
      [xAxis]="showXAxis4"
      [yAxis]="showYAxis4"
      [legend]="showLegend4"
      [showXAxisLabel]="showXAxisLabel4"
      [showYAxisLabel]="showYAxisLabel4"
      [xAxisLabel]="xAxisLabel4"
      [yAxisLabel]="yAxisLabel4"
      [yAxisLabel]="yAxisLabel4"
      (select)="onSelect($event)"
      (activate)="onActivate($event)"
      (deactivate)="onDeactivate($event)">
    </ngx-charts-bar-horizontal>

    
    
  </div>
    




</div>




